<template>
  <div class="picnic-dots">
    <portal class="ps-marker-portal">
      <the-dot
        v-for="d in visibleDots"
        :key="d.id"
        :dot="d"
        :active-id="routerCardId"
        :active-route="activeRoute"
        :is-visible="isVisible"
        :provider-user-id="currentUserProviderId"
      ></the-dot>

      <the-dot
        v-if="dotCreate.position"
        key="picnic-team-create-dot"
        :dot="dotCreate"
        :is-create-mode="true"
        :is-visible="isVisible"
      ></the-dot>
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapState } from '@picnic-software/vuex'
import debounce from 'lodash.debounce'
import anime from 'animejs'
import shake from 'shake.js'
import TheDot from '@/components/TheDot'
import { Portal } from '@linusborg/vue-simple-portal'

export default {
  name: 'AppDots',
  components: {
    TheDot,
    Portal
  },
  created() {
    this.bindEvents()
  },
  mounted() {
    this.$nextTick(() => (this.windowWidth = window.innerWidth))
  },
  data() {
    return {
      hidden: false,
      previousRoute: null
    }
  },
  computed: {
    ...mapState({
      dotsByPage: state => state.pages.dots.all,
      dotCreate: state => state.dots.active.core,
      routerCardId: state => state.router.cardId,
      activeRoute: state => state.router.active,
      isAppVisible: state => state.app.isVisible,
      isPageDotsVisible: state => state.pages.dots.isVisible,
      currentUserProviderId: state => state.auth.user.provider_user_id
    }),
    ...mapGetters({
      isDone: 'provider/list/isDone'
    }),
    visibleDots() {
      return this.dotsByPage.filter(
        d => !d.is_done && d.is_active && d.selector
      )
    },
    isVisible() {
      return this.isAppVisible
    }
  },
  methods: {
    bindEvents() {
      window.addEventListener(
        'resize',
        debounce(this.handleHideAnnotations, 300, {
          leading: true,
          trailing: false
        }),
        false
      )
      // Add the event listener
      window.addEventListener(
        'resize',
        debounce(this.handleShowAnnotations, 1000, {
          leading: false,
          trailing: true
        }),
        false
      )

      this.setupShakeListener()
      this.setupKeyboardListener()
    },

    handleHideAnnotations() {
      // Guard if window width has not changed
      if (window.innerWidth === this.windowWidth || this.hidden) {
        return
      }

      // Update window width value with new value
      this.windowWidth = window.innerWidth
      this.hidden = true
      this.hideAnnotations()
    },

    hideAnnotations() {
      anime({
        targets: this.dotsEls,
        scale: 0,
        duration: 10,
        easing: 'easeOutQuad',
        loop: false
      })
    },

    handleShowAnnotations() {
      if (!this.hidden) {
        return
      }
      // console.log('run show annoatations')
      this.hidden = false
      // this.restoreAnnotations()
    },

    restoreAnnotations() {
      this.dots.forEach(d => d.position())
      anime({
        targets: this.dotsEls,
        scale: [1.4, 1],
        duration: 100,
        easing: 'easeInQuad',
        loop: false
      })
    },

    /**
     * Shake Events
     */

    setupShakeListener() {
      let shakeDetector = new shake({
        threshold: 12,
        timeout: 800 // optional, determines the frequency of event generation
      })
      shakeDetector.start()
      window.addEventListener('shake', this.toggleInterface, false)
    },

    setupKeyboardListener() {
      window.addEventListener('keydown', this.verfiyKeyCodes)
    },

    verfiyKeyCodes(e) {
      if (e.key === 'P' && e.ctrlKey && e.shiftKey) {
        this.toggleInterface()
      }
    },

    toggleInterface() {
      // if (this.$store.getters.route !== 'default' && this.$store.getters.route !== 'shake') { return }
      if (!this.hiddenOverride && !this.hidden) {
        // console.log('hide annotations')
        this.hideAnnotations()
        this.hiddenOverride = true
        this.previousRoute = this.$store.getters.route
        this.$store.dispatch('route', 'shake')
      } else {
        // console.log('restore annotations')
        // console.log(this.previousRoute)
        this.restoreAnnotations()
        this.hiddenOverride = false
        this.$store.dispatch('route', this.previousRoute)
      }
    },
    beforeEnter: function(el) {},
    enter: function(el, done) {
      let grow = 1
      let extend = 1.4
      if (this.ticketCreate) {
        grow = 2.5
        extend = 2.9
      }
      anime({
        targets: el,
        scale: [0, extend, grow],
        duration: 700,
        easing: 'easeInQuad',
        loop: false,
        delay: 2000
      }).finished.then(() => done())
    },
    leave: function(el, done) {
      let grow = 1
      let extend = 3
      if (this.ticketCreate) {
        grow = 2.5
        extend = 2.9
      }
      anime({
        targets: el,
        scale: [grow, extend, 0],
        duration: 700,
        easing: 'easeOutQuad',
        loop: false,
        delay: 200
      }).finished.then(() => done())
    }
  }
}
</script>

